<template>
  <div>
    <v-container class="pa-0" fluid>
      <v-row style="height: 48px; max-height: 48px">
        <ContenidoBase
          :EstadoBtn="EstadoBtn"
          :descripcion="'Listado de precios.'"
          :show-absolute="false"
          :titulo="'Lista de Precios'"
          @MethodAnular="anular"
          @MethodEliminar="remove"
          @MethodGuardar="save"
          @MethodImprimir="imprimirList"
          @MethodNuevo="newwnuevo"
          @abrirBarraTablaDinamica="abrirTabla"
        />
      </v-row>

      <v-row>
        <!-- contenido central ------------------------------------------------------------------------------ -->
        <v-col :max-height="this.windowSize.height - 96">
          <v-app
            id="inspire"
            class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }"
          >
            <!--- Formulario --->
            <v-container>
              <v-card color="grey lighten-3">
                <v-toolbar color="#BDBDBD" dense flat style="border: 1px solid #000000">
                  <v-avatar size="45" tile>
                    <img alt="Reporte" src="@/assets/iconos_micromarket/custom-reports.png" />
                  </v-avatar>

                  <span class="font-weight-light" style="font-size: 20px">Reporte lista de precios</span>
                </v-toolbar>

                <hr />

                <v-container style="border: 1px solid #000000">
                  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="">
                    <v-row>
                      <!-- columna 1 -->
                      <v-col cols="12" md="6" sm="6">
                        <!--- Departamento --->
                        <v-autocomplete
                          v-model="datos.departamento"
                          :items="departamentoList"
                          clearable
                          dense
                          item-text="descripcion"
                          label="Departamento"
                          outlined
                          return-object
                          @focus.once="findAllDepartamentos"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-building-o" style="font-size: 20px; width: 1.3rem"></i>
                          </template>
                        </v-autocomplete>
                      </v-col>

                      <!-- columna 2 -->
                      <v-col cols="12" md="6" sm="6">
                        <!--- Fabricante --->
                        <v-autocomplete
                          v-model="datos.fabricante"
                          :items="fabricanteList"
                          :search-input.sync="searchFabricante"
                          clearable
                          dense
                          item-text="nombre"
                          label="Fabricante"
                          no-filter
                          outlined
                          return-object
                          @focus.once="findFabricante"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-users" style="font-size: 20px; width: 1.3rem"></i>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <!-- fn columna 2 -->
                    </v-row>
                  </v-form>
                </v-container>

                <hr />

                <ModalReporteFiltros ref="ModRepFilt" :Datos="datos" @DataReporteBasico="DDataReporteBasico" />
              </v-card>
            </v-container>
            <!-- fn Formulario-Historial de consumo del cliente-->
          </v-app>
        </v-col>
        <!-- fn contenido central ------------------------------------------------------------------------------------->
      </v-row>
    </v-container>
    <!-- Modales -------------------------------------------------------------------------------------------------->

    <!------------otras funciones---------------->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      :timeout="120000"
      :vertical="true"
      style="margin-top: 20%"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <!-- fn Modales ----------------------------------------------------------------------------------------------->
  </div>
</template>

<script>
  import { EventBus } from "@/event-bus"
  import BarraBusqueda2 from "../../components/BarraBusquedaDinam"
  import ContenidoBase from "../../components/ContenidoBase"
  import ModalReporteFiltros from "../../components/ModalReporteFiltros2"

  import { fechaNueva, FormatoFecha } from "@/js/Funciones.js"

  export default {
    components: {
      BarraBusqueda2,
      ContenidoBase,
      ModalReporteFiltros,
    },
    created() {
      var json = {
        titulo: "Historial de consumo del cliente",
        descripcion: "Imprime el historial de consumo del cliente.",
        save: false,
        eliminar: false,
        anular: false,
        nuevo: false,
        imprimir: false,
      }
      EventBus.$emit("anularBotonesAccion", json)
    },

    mounted() {
      EventBus.$on("abrirMenuizquierdo", this.abrirTabla)
      // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
      // EventBus.$on("ReporteCumpleañosClientesNew", this.new);
      // EventBus.$on("ReporteCumpleañosClientesSave", this.save);
      // EventBus.$on("ReporteCumpleañosClientesRemove", this.remove);
      // EventBus.$on("ReporteCumpleañosClientesAnular", this.remove);
      // EventBus.$on("ReporteCumpleañosClientesPrintList", this.imprimirList);
      // EventBus.$on("emitReporteCumpleañosClientes", this.datostabla);

      this.$refs.ModRepFilt.CrearObjecto = this.validarObjecto
      EventBus.$on("onResize", this.onResize)
    },

    data: () => ({
      windowSize: { width: "auto", height: "auto" },
      Rcliente: [],
      datos: {
        nombre: "Lista De Precios",
        titulo: "Lista De Precios",
        UrlImprimir: "/reportes-pv/imprimirListaDePrecios",
        UrlExel: "/reportes-pv/excelListaDePrecios",
        UrlCorreo: "/reportes-pv/correoFacturasAVencer",
        fabricante: null,
        departamento: null,
      },

      departamentoList: [],
      fabricanteList: [],
      searchFabricante: "",

      EstadoBtn: {
        BarraTablaDinamicaAprir: false,
        nuevo: false,
        guardar: false,
        eliminar: false,
        anular: false,
        imprimir: false,
        vercuenta: false,
        guardartemporal: false,
        restaurartemporal: false,
        importarDato: false,
        cargarProducto: false,
        ImprimirproductoInv: false,
      },

      text: "",
      valid: true,
      BarraTablaDinamicaAprir: false,
      BarraSecundariaAprir: false,

      aalert: {
        estado: false,
        color: null,
      },
    }),

    methods: {
      FormatoFecha,
      fechaNueva,
      onResize(e) {
        this.windowSize = e
      },

      // Validando el formulario y luego configurando el valor de la propiedad cliente del objeto
      validarObjecto() {
        if (!this.$refs.form.validate()) {
          this.$refs.ModRepFilt.detener = true
          return
        } else {
          this.$refs.ModRepFilt.detener = false
        }
      },

      // Buscar cliente
      findAllDepartamentos() {
        this.$axios
          .get(this.$hostname + this.$hName + "/departamento/activo", {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.departamentoList = res.data
          })
          .catch((err) => {
            console.error(err)
          })
      },

      // Buscar fabricante
      findFabricante() {
        this.$axios
          .get(this.$hostname + this.$hName + "/fabricante/findAll", {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              nombre: this.searchFabricante,
            },
          })
          .then((res) => {
            this.fabricanteList = res.data.content
          })
          .catch((err) => {
            console.error(err)
          })
      },

      abrirTabla() {
        this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir
      },

      save() {},
      remove() {},
      anular() {},
      imprimirList() {},
      DDataReporteBasico() {},

      newwnuevo() {},

      // Valida si el campo esta nulo, si lo esta coloca la fecha actual.
      BlurDesde() {
        if (this.datos.desde.toString().length === 0) {
          this.datos.desde = this.fechaNueva()
        }
      },

      // Valida si el campo esta nulo, si lo esta coloca la fecha actual.
      BlurHasta() {
        if (this.datos.hasta.toString().length === 0) {
          this.datos.hasta = this.fechaNueva()
        }
      },

      alerta(e, l) {
        if (l === "bien") {
          this.aalert.estado = true
          this.aalert.color = "success"
          this.aalert.nombre = e
          this.newwnuevo()
        }

        if (l === "error") {
          this.aalert.estado = true
          this.aalert.color = "error"
          this.aalert.nombre = e
          this.ejecucion = false
        }
      },
    },
    watch: {
      searchFabricante() {
        this.findFabricante()
      },
    },
  }
</script>

<style></style>
